import { get } from "lodash";
import React from "react";
import { EditButton as RaEditButton, useTranslate } from "react-admin";

const EditButton = ({ isAdmin, ...props }) => {
	const translate = useTranslate();
	const canUpload = get(
		props.record,
		`can_upload${isAdmin ? "_admin" : ""}`,
		false
	);
	if (!canUpload) {
		return null;
	}
	return (
		<RaEditButton
			variant="contained"
			{...props}
			label={translate("resources.user-payments.buttons.upload_invoice")}
		/>
	);
};
export default EditButton;
